<template>
  <div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="标题">
            <a-input v-model="searchForm.title" allowClear placeholder="请输入标题" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformOriginList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="分类">
            <a-select v-model="searchForm.typeid" allowClear show-search option-filter-prop="children" placeholder="请选择平台分类" style="width: 100%">
              <a-select-option v-for="item in classifyList" :key="item.id" :value="item.id">{{
                item.path_name
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优先级">
            <a-select v-model="searchForm.priority_level" allowClear show-search option-filter-prop="children" placeholder="请选择优先级" style="width: 100%">
              <a-select-option v-for="item in ARTICLE_PRIORITY_LEVEL" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select v-model="searchForm.status" allowClear show-search option-filter-prop="children" placeholder="请选择状态" style="width: 100%" @change="stateChange">
              <a-select-option v-for="item in ARTICLE_STATUS" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="标签id">
            <a-input-number @change="stateChange" :min="0" :precision="0" v-model="searchForm.label_id" placeholder="请输入标签id" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布人">
            <a-input
              v-model="searchForm.add_person_keyword"
              allowClear
              placeholder="请输入发布人"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="审核人">
            <a-input v-model="searchForm.reviewed_keyword" allowClear placeholder="请输入审核人" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="最后修改人">
            <a-input
              v-model="searchForm.last_modify_keyword"
              allowClear
              placeholder="请输入最后修改人"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布时间">
            <v-range-picker v-model="times" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="审核时间">
            <a-range-picker
              v-model="reviewed_at"
              value-format="X"
              :placeholder="['开始时间', '结束时间']"
              allowClear
              @change="reviewedTimeChange"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="最后修改时间">
            <a-range-picker
              v-model="last_modify_at"
              value-format="X"
              :placeholder="['开始时间', '结束时间']"
              allowClear
              @change="modifyTimeChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAddAricle">添加文章</a-button>
        <a-button icon="plus-circle" style="margin-left:5px;" @click="handleBatchCreateArticle">模板批量生成文章</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
        <!-- <a-button icon="sync">刷新表格</a-button> -->
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <a-table-column title="序号" data-index="id" align="center" :width="100" />
      <a-table-column :ellipsis="true" title="发布平台" data-index="org" align="left">
        <template v-slot="text">
          {{ text }}
        </template>
      </a-table-column>
      <a-table-column title="标题" data-index="title" :width="220" align="left">
        <template v-slot="text, record">
          <a v-if="record.pc_detail_url" :href="record.pc_detail_url" target="_blank">{{ text }}</a>
          <span v-else>{{ text }}</span>
        </template>
      </a-table-column>
      <a-table-column title="分类" data-index="typeid" :width="120" align="center">
        <template v-slot="text">
          {{ showListName(text, 'classify') }}
        </template>
      </a-table-column>
      <a-table-column title="优先级" :width="110" data-index="iscommend" align="center">
        <template v-slot="text, record">
          {{ text ? '推荐' : '不推荐' }}{{ record.istop ? '置顶' : '不置顶' }}
        </template>
      </a-table-column>
      <a-table-column title="评论数" :width="80" data-index="comment" align="center" />
      <a-table-column title="点赞数" :width="80" data-index="click_like" align="center" />
      <a-table-column title="阅读量" :width="80" data-index="click" align="center" />
      <a-table-column title="人员" :width="180" align="left">
        <template slot-scope="text, record">
          <div>
            <span>发布：</span>
            <span v-if="record.add_person_name">{{ record.add_person_name }}</span>
            <span v-if="record.add_person_name && record.add_person"> ({{ record.add_person }})</span>
            <span v-else>-</span>
          </div>
          <div>
            <span>审核：</span>
            <span v-if="record.reviewed_name">{{ record.reviewed_name }}</span>
            <span v-if="record.reviewed_name && record.reviewed_number"> ({{ record.reviewed_number }})</span>
            <span v-else>-</span>
          </div>
          <div>
            <span>最后修改：</span>
            <span v-if="record.last_modify_name">{{ record.last_modify_name }}</span>
            <span v-if="record.last_modify_name && record.last_modify"> ({{ record.last_modify }})</span>
            <span v-else>-</span>
          </div>
        </template>
      </a-table-column>
      <a-table-column title="状态" data-index="status" :width="100" align="left">
        <template v-slot="text">
          <span v-if="text === 0" style="color: #FE9501;">{{ showName('ARTICLE_STATUS', text) }}</span>
          <span v-else-if="text === 1" style="color:#18BE6D;" color="green">{{ showName('ARTICLE_STATUS', text) }}</span>
          <span v-else-if="text === 2" style="color: red;">{{ showName('ARTICLE_STATUS', text) }}</span>
          <span v-else-if="text === 3" style="color: #FF5800;">{{ showName('ARTICLE_STATUS', text) }}</span>
          <span v-else color="orange">--</span>
        </template>
      </a-table-column>
      <a-table-column title="时间" :width="240" align="left">
        <template slot-scope="text, record">
          <div>
            <span>发布：</span>
            <span v-if="record.created_at">{{ record.created_at | parseTime }}</span>
            <span v-else>-</span>
          </div>
          <div>
            <span>审核：</span>
            <span v-if="record.reviewed_at">{{ record.reviewed_at | parseTime }}</span>
            <span v-else>-</span>
          </div>
          <div>
            <span>最后修改：</span>
            <span v-if="record.last_modify_at">{{ record.last_modify_at | parseTime }}</span>
            <span v-else>-</span>
          </div>
        </template>
      </a-table-column>
      <a-table-column title="操作" data-index="mo4ne5y" :width="140" align="center" fixed="right">
        <template slot-scope="text, record">
          <div class="flex-sb">
            <a-popconfirm title="请选择通过与否" ok-text="通过" cancel-text="不通过" @confirm="handleTableCommand('check', record, 1)" @cancel="handleTableCommand('check', record, 2)">
              <a-button v-if="record.status === 0 || record.status === 3" size="small" type="link">审核</a-button>
            </a-popconfirm>
            <a-button size="small" type="link" v-if="record.status === 1" @click="handleTableCommand('check', record, 3)">下架</a-button>
            <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
            <a-dropdown>
              <a-button size="small" type="link" class="ant-dropdown-link" @click="e => e.preventDefault()">
                更多
                <a-icon type="down" />
              </a-button>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a-button size="small" type="link" @click="goList(record, '/group-web/article/comment?id=')">评论记录</a-button>
                </a-menu-item>
                <a-menu-item>
                  <a-button size="small" type="link" @click="goList(record, '/group-web/article/like?id=')">点赞记录</a-button>
                </a-menu-item>
                <a-menu-item>
                  <a-button size="small" type="link" @click="goHistoryList(record.id)">浏览记录</a-button>
                </a-menu-item>
                <a-menu-item>
                  <a-button v-if="record.status === 0 || record.status === 2 || record.status === 3" size="small" type="link" @click="handleTableCommand('delete', record)">删除</a-button>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </template>
      </a-table-column>
    </a-table>

    <!-- 添加文章 -->
    <a-modal width="40%" v-model="visible" title="选择模板" :afterClose="handleCancel">
      <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="选择业务线" prop="line_id">
          <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请输入或选择" @change="handlePlatform">
            <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
              item.org
            }}</a-select-option>
          </a-select>
          <!-- <a-cascader :options="platformList" change-on-select placeholder="请输入或选择" @change="onChange" /> -->
        </a-form-model-item>
        <a-form-model-item label="模板名称" prop="id">
          <a-select v-model="form.id" allowClear show-search option-filter-prop="children" placeholder="请输入或选择">
            <!-- <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">{{
              item.name
            }}</a-select-option> -->
            <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item label="是否使用默认模板">
          <a-radio-group v-model="form.default">
            <a-radio v-for="item in ARTICLE_IS_TOP" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
          </a-radio-group>
        </a-form-model-item> -->
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取 消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit"> 提 交 </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { reactive, onMounted, onUnmounted, toRefs, getCurrentInstance, watch } from '@vue/composition-api'
import { strategyCommand } from './business/tableLogic'
import { searchForm, form, rules } from './business/articleList'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed'
import api from '@/api/'
// import store from '@/store'
import computed from '@/views/active/awardWin/computed'

export default {
  name: 'ArticleList',
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()
    // const getSearchState = computed({ get: () => store.state.searchForm.data })
    // 分页信息
    const pagData = pagination()
    const { handleTableChange } = pagData
    // 标签id
    const labelId = computed(() => _this.$route.query.id)

    const state = reactive({
      ...pagData,
      rules,
      times: [],
      reviewed_at: [],
      last_modify_at: [],
      templateList: [],
      form: { ...form },
      temForm: { template_type: 1, state: 1, line_id: undefined }, // 模板表单
      classifyList: [], // 分类列表
      platformOriginList: [], // 发布平台带二三级
      platformList: [], // 发布平台
      searchForm: { ...searchForm }
    })
    onMounted(async () => {
      methods.getArticleClassify()
      methods.getPlatform()
      state.searchForm = _this.SEARCH_FORM
      state.times = _this.SEARCH_FORMDAY
      if (_this.$route.query.id) {
        state.searchForm.label_id = Number(_this.$route.query.id)
        state.searchForm.status = 1
      }
      await methods.getList()
    })
    onUnmounted(async () => {
      if (!_this.$route.query.status) {
        _this.SET_SEARCH[0]({})
        _this.SET_SEARCHDAY[0]([])
      }
    })
    watch(
      () => state.form.line_id,
      () => {
        if (state.form.line_id) {
          state.form.id = 0
        } else {
          state.form.id = undefined
          _this.templateList = []
        }
      }
    )

    const methods = {
      stateChange() {
        this.$forceUpdate()
      },
      search() {
        _this.pagination.current = 1
        _this.SET_SEARCHDAY[0](state.times)
        _this.SET_SEARCH[0](state.searchForm)
        this.getList()
      },

      async getList() {
        state.loading = true
        state.searchForm.start_date = state.times[0]
        state.searchForm.end_date = state.times[1]
        const res = await api.listArticle({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        if (!res.data) {
          state.loading = false
          return
        }
        const { article, pagination } = res.data
        state.data = article || []
        state.pagination.total = pagination.total
        state.loading = false
      },

      async getTemplate(data) {
        const res = await api.listTemplate(data)
        const { template } = res.data
        _this.templateList = template
        _this.templateList.unshift({ name: '默认模板', id: 0 })
      },

      // 获取发布平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.platformOriginList = res.data
        state.platformList = res.data.filter(item => {
          if (item.parent_id === 0) {
            return item
          }
        })
      },
      goList(record, url) {
        this.$router.push({ path: url + record.id })
      },
      goHistoryList(id) {
        this.$router.push({
          path: `/group-web/article/read_record`,
          query: { id }
        })
      },
      handlePlatform(id) {
        if (id) {
          state.temForm.line_id = id
          state.form.id = ''
          methods.getTemplate(state.temForm)
        }
      },

      handleSubmit() {
        // if (state.form.default) {
        //   _this.$router.push('/article/edit')
        // } else {
        _this.$refs.formDom.validate(async valid => {
          if (valid) {
            const { line_id } = state.temForm
            if (this.form.id === 0) {
              _this.$router.push(`/article/edit/?line_id=${line_id}`)
            } else {
              _this.$router.push(`/article/template/${state.form.id}?line_id=${line_id}&type=1`)
            }
          }
        })
        // }
      },

      handleCancel() {
        _this.$refs.formDom.resetFields()
        state.visible = false
      },

      handleAddAricle() {
        state.visible = true
      },

      handleBatchCreateArticle() {
        _this.$router.push('/article/choosetemplate')
      },

      // 清除
      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        state.reviewed_at = []
        state.last_modify_at = []
        this.search()
      },

      // 表格操作
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      // 获取文章分类
      async getArticleClassify() {
        const res = await api.listClassify()
          state.classifyList = res?.data?.articleType
      },
      reviewedTimeChange(val) {
        state.searchForm.reviewed_at_start = val[0]
        state.searchForm.reviewed_at_end = val[1]
      },
      modifyTimeChange(val) {
        state.searchForm.last_modify_at_start = val[0]
        state.searchForm.last_modify_at_end = val[1]
      },
      showListName(id, type) {
        switch (type) {
          case 'classify':
            const classify = state.classifyList.filter(item => Number(item.id) === Number(id))[0]
            return (classify && classify.type_name) || '--'
          case 'platform':
            const platform = state.platformList.filter(item => Number(item.id) === Number(id))[0]
            return (platform && platform.name) || '--'
        }
      },
      handleTableChange
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods
    }
  }
}
</script>
<style lang='less'>
.anticon-down {
  margin-left: 0 !important;
}
</style>
